import ky from 'ky'
import { DateTime } from 'luxon'

import { BackstageTagResponse, Artist, TimeSlot, TimeSlotJson } from './types'

export const getBackstageNews = async (): Promise<BackstageTagResponse> => {
  return await ky.get('https://backstage.slipmat.io/tags/homepage_news.json').json()
}

export const getArtists = async (): Promise<Artist[]> => {
  return await ky.get('/api/artists').json()
  // .catch(function() {
  //   console.log('Hell no.')
  //   return []
  // })
}

export const getTimeSlots = async (): Promise<TimeSlot[]> => {
  const slots: TimeSlotJson[] = await ky.get('/api/timeslots').json()
  const finalSlots: TimeSlot[] = []

  slots.forEach((slot) => {
    const newTime = DateTime.fromISO(slot.time)
    finalSlots.push({
      id: slot.id,
      time: newTime,
      artistId: slot.artistId,
      status: slot.status,
    })
  })
  return finalSlots
  // .catch(function() {
  //   console.log('Hell no.')
  //   return []
  // })
}
